export const FLAT_RATE = 'flat_rate';
export const PERCENT_OF_RENT = 'percent_of_rent';
export const RATE_PER_SPACE_SIZE_UNIT = 'rate_per_space_size_unit';
export const RATE_PER_SPACE_SIZE_UNIT_PER_MONTH = 'rate_per_space_size_unit_per_month';
export const RATE_PER_SPACE_SIZE_UNIT_PER_YEAR = 'rate_per_space_size_unit_per_year';

export const commissionModes = [
  FLAT_RATE,
  PERCENT_OF_RENT,
  RATE_PER_SPACE_SIZE_UNIT,
  RATE_PER_SPACE_SIZE_UNIT_PER_MONTH,
  RATE_PER_SPACE_SIZE_UNIT_PER_YEAR
];
